import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL;
const functionkey = process.env.REACT_APP_FUNCTION_KEY;
const config = {
    headers: {
        "x-functions-key": functionkey,
    },
}
export async function getter(request) {
    const url = baseURL + request;
    return await axios
        .get(url, config)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });
}

export function poster(request, data, setter) {
    const url = baseURL + request;
    axios
        .post(url, data, config)
        .then((response) => {
            setter(response.data);
        })
        .catch((error) => {
            console.log(error);
        });
}
export function putter(request, data, setter) {
    const url = baseURL + request;

    axios
        .put(url, data, config)
        .then((response) => {
            setter(response.data);
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function deleter(request) {
    const url = baseURL + request;
    const result = await axios
        .delete(url, config)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
        });
    return result;
}

export function logActivity(operation, userId = null) {
    const url = baseURL + "log";
    const data = {
        operation: operation,
        user_id: userId,
    };
    axios
        .post(url, data, config)
        .then((response) => {
            console.log("Activity logged:", response.data);
        })
        .catch((error) => {
            console.error("Failed to log activity:", error);
        });
}